import { Injectable } from '@angular/core';
import { E5ConfigurationService } from 'e5core-angular-services';
import { Guid } from 'guid-typescript';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { WorkHistoryFrameModel, WorkHistoryDtoModel } from '../models/work-history.model';
import { OdataOptions } from './odata-options';

@Injectable({
  providedIn: 'root'
})
export class HistoryOdataService {

  constructor(private http: HttpClient, private config:E5ConfigurationService) { }

  // apiServer: {
  //   baseUrl: 'http://vlane5dev2016:84',
  //   scope: 'test'
  // }
  // e.g. http://localhost:12661/site/odata/Ui/History/8b50f520-cac0-11e8-a32f-00155d2a720c?$count=true&$top=2&$skip=2
  //
  //   {
  //     "WorkId": "8b50f520-cac0-11e8-a32f-00155d2a720c",
  //     "Id": 618315,
  //     "EventDate": "2018-10-08T17:09:00.157+11:00",
  //     "EventId": 100,
  //     "EventName": "Changed Work Status",
  //     "EventUser": "LOCALDEV\\pfinch",
  //     "StatusId": 1,
  //     "StatusName": "Active",
  //     "Detail": "Launched",
  //     "Allocation": "1|1|1|0"
  //  },
  public getHistory(workId:string, page:number, pagesize:number, options? : OdataOptions ):BehaviorSubject<WorkHistoryFrameModel> {
    let subject$ = new BehaviorSubject<WorkHistoryFrameModel>(new WorkHistoryFrameModel()) ;
    let baseUrl = this.config.settings.apiServer.baseUrl ;
    let scope = this.config.settings.apiServer.scope ;
    let offset = page * pagesize ;
    let url = `${baseUrl}/${scope}/odata/Ui/History/${workId.toString()}?$count=true&$top=${pagesize||10}&$skip=${offset||0}` ;

    // Append orderby
    if(options && options.orderby && options.orderby !== "")
      url += `&$orderby=${encodeURIComponent(options.orderby)}` ;

    this.http.get<WorkHistoryDtoModel>(url).subscribe(
      result => {
        let whf = new WorkHistoryFrameModel() ;
        whf.count = result["@odata.count"] ;
        whf.page = page ;
        whf.pagesize = pagesize ;
        whf.data = result.value ;
        subject$.next(whf) ;
      },
      error => {
        console.error(error);
        subject$.error(error) ;
      }
    )
    return (subject$);
  }
}
